import { Inject, Injectable, OnInit } from '@angular/core';

import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {

  constructor(
    private messageService: MessageService
  ) {
  }

  success(detail?: string): any {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: detail ? detail : 'Save Success' });
  }


  error(detail?: string): any {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Message Content' });
  }

  warn(title?: string, detail?: string) {
    this.messageService.add({ severity: 'warn', summary: 'แจ้งเตือน', detail: 'Message Content' });
  }

  deleteSuccess(detail?: string): any {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: detail ? detail : 'Delete Success' });
  }

  updateStatusSuccess(detail?: string): any {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: detail ? detail : 'Update Success' });
  }

}
